import React from 'react';

import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getConvertedUnitName,
  getPropertyValue,
  formatPropertyTime,
  capitalizeFirstLetter,
} from 'web-utils';

type Props = {
  property: any,
};

const mapState = state => ({
  settings: coreSelectors.getProfile('user_settings')(state),
  properties: coreSelectors.getVisiblePersonalProperties(state),
});

const ExercisePropertyLabel = ({ property }: Props) => {
  const { settings } = useSelector(mapState, shallowEqual);
  if (!property) {
    return null;
  }

  const pp = property.exercise_property?.personal_property || property.personal_property || {};
  const name = pp.name || 'No property type';

  if (!property?.value) {
    return (
      <span>
        {name}
      </span>
    );
  }

  const unit = getConvertedUnitName(property.property_unit_name, settings.units_system);
  if (unit === 's' || unit === 'mmss') {
    return (
      <span>
        {name.split(' ')[0]}
        {' - '}
        {formatPropertyTime(property.value)}
      </span>
    );
  }

  const value = getPropertyValue(property, unit);
  return (
    <span>
      {value}
      {' '}
      {capitalizeFirstLetter(unit)}
    </span>
  );
};

export default ExercisePropertyLabel;
